<template>
    <div id="cliniques-index" class="page-wrapper" v-if="pageIsLoaded">
        <!-- Hero -->
        <section class="main-hero">
            <div class="col col-content">
                <h1 class="big-title" data-inview="fadeInUp" data-delay="100">
                    {{ content.title }}
                </h1>
                <p class="regular-text" data-inview="fadeInUp" data-delay="300">
                    {{ content.courtText }}
                </p>
            </div>
            <div class="col col-img" data-inview="revealRight" data-delay="100">
                <img :src="content.imageDetails.url" :alt="content.imageDetails.title" />
            </div>
        </section>

        <!-- Details -->
        <article class="article-details">
            <svg
                class="particle"
                height="46"
                viewBox="0 0 315 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                data-inview="fadeInUp"
                data-delay="400"
            >
                <path
                    d="M0.247544 0C3.46562 1.89689 6.55992 3.9175 9.61297 5.89686C12.666 7.87623 15.9253 9.64941 18.9784 11.5463L28.3851 16.8246C31.5619 18.5566 34.7387 20.1236 37.9155 21.773C50.4423 28.06 63.419 33.408 76.7387 37.7729C102.837 46.2878 130.108 50.6706 157.562 50.7625C185.027 50.7192 212.314 46.3638 238.426 37.8554C251.762 33.4982 264.753 28.1499 277.291 21.8555C280.426 20.2473 283.644 18.639 286.821 16.9483L296.228 11.6288C299.322 9.73188 302.499 7.91746 305.593 6.02057C308.688 4.12368 311.782 1.89689 315 0.0824755C312.978 3.21647 310.874 6.22676 308.564 9.23705C306.253 12.2473 303.819 15.0514 301.385 17.8968C298.951 20.7421 296.228 23.34 293.587 26.1441C292.308 27.5462 290.864 28.7008 289.462 30.0204L285.336 33.8142C273.724 43.7532 260.935 52.2289 247.255 59.0511C245.564 59.9583 243.79 60.7006 242.057 61.5253L236.776 63.917C235.043 64.7418 233.228 65.3191 231.413 66.0613L226.008 68.1232C222.377 69.4428 218.705 70.5562 214.992 71.752C211.279 72.9479 207.525 73.7314 203.77 74.7211C188.646 78.2304 173.171 80.0014 157.644 79.9994C126.547 80.0766 95.8565 72.9337 67.9921 59.1336C54.3074 52.3205 41.5171 43.844 29.9116 33.8967L25.7859 30.1029C24.4244 28.8245 22.9391 27.6286 21.6601 26.2678C19.0196 23.505 16.3379 20.9071 13.8625 18.0205C11.387 15.1339 8.99411 12.2886 6.68369 9.36075C4.37328 6.43294 2.06287 3.29894 0 0.206181L0.247544 0Z"
                    fill="#BEE0D9"
                />
            </svg>

            <div class="article-details-inner">
                <div class="max-container">
                    <div v-html="content.details"></div>

                    <!-- CTA -->
                    <article class="cta" data-inview="fadeInUp" data-delay="200">
                        <h3 class="medium-title">{{ content.cta.titre }}</h3>
                        <a
                            href="#"
                            :title="content.cta.bouton.customText"
                            @click.prevent="togglePanel('rendez-vous')"
                            class="site-btn alternate"
                            >{{ content.cta.bouton.customText }}</a
                        >
                    </article>
                </div>
            </div>
        </article>
    </div>
    <PageLoader v-else />
</template>

<script>
import { initInViewAnimations } from '@/plugins/InViewAnimations'

import { mapState, mapGetters, mapActions } from 'vuex'
import PageLoader from '@/components/PageLoader.vue'

export default {
    name: 'TraitementsEntry',

    components: {
        PageLoader,
    },

    watch: {
        pageIsLoaded: {
            handler(pageIsLoaded) {
                if (pageIsLoaded) {
                    // Page load buffer
                    setTimeout(() => {
                        initInViewAnimations()
                    }, 155)
                }
            },
            immediate: true,
        },
    },

    methods: {
        ...mapActions(['togglePanel']),
    },

    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.page-wrapper {
    min-height: 90vh;
}

.main-hero .col-content {
    min-height: inherit;
}

.article-details {
    padding-top: 145px;

    @media (max-width: 900px) {
        padding-top: 45px;
    }
}

.article-details .article-details-inner {
    background: transparent;
}

.article-details .max-container {
    max-width: 1200px;
}

.article-details .particle {
    top: 75px;
    left: 50%;
    transform: translate(-50%, 0);
}
</style>
